import React, { useEffect, useState } from 'react'
import AppLayout from '../../../../layout/components/AppLayout'
import DateSelect from '../../../../components/AppInput/DateSelect';
import useSystemMasterList from '../../../../hooks/useSystemMasterList';
import reportsServices from '../reportsServices';
import StatusCounterByGroup from '../components/StatusCounterByGroup';

function GrievanceStatusReportByGroupPage() {
	const [masters,getMasterLabel] = useSystemMasterList(['grievance-type','grievance-status']);
	const [filter,setFilter] = useState(null);
	const [supervisorList,setSupervisorList] = useState(null);

	const getGreivanceList = () =>{
		if(masters){
			setSupervisorList(null);
			const payload = {
				startDate:filter.startDate,
				endDate:filter.endDate
			}
			reportsServices.getGrievanceByGroup(payload).then(res=>{
			setSupervisorList(res.data);
			}).catch(error=>{
			}).finally(()=>{
			})
		}
	}

	useEffect(()=>{
		getGreivanceList();
	},[filter,masters])

  return (
    <AppLayout>
		<div className='container-fluid'>
			<div className='row mb-3'>
                <div className='col-md-12'>
                    <div class="p-2 bg-dark text-center text-white rounded">
                        <h3 className='mb-0' >Supervisor Grievance</h3>
                    </div>
                </div>
            </div>
			<div className='row mb-3'>
				<div className='col-md-12'>
					<span className='float-end'><DateSelect filter={filter} setFilter={setFilter} /></span>
				</div>
			</div>
			<div className='row mb-3'>
				<div className='col-md-12'>
					{ supervisorList && supervisorList.map(supervisor=>
                        masters && supervisor.assignedGrievanceType !==null &&
						<StatusCounterByGroup
                            reportData={supervisor.grievanceList} 
                            assignedGrievanceType={supervisor.assignedGrievanceType.split(",").map(Number)}
                            masters={masters}
                            supervisorName={supervisor.firstName+" "+supervisor.lastName} 
                            getMasterLabel={getMasterLabel}
                        />
					)}
				</div>
			</div>
			
		</div>
    </AppLayout>
  )
}

export default GrievanceStatusReportByGroupPage